import { render, staticRenderFns } from "./InviteVendors.vue?vue&type=template&id=dcb490ae&"
import script from "./InviteVendors.vue?vue&type=script&lang=js&"
export * from "./InviteVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports